import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var KTComponents: any;

@Injectable({
  providedIn: 'root'
})
export class MetronicService {

  constructor(private router: Router) {}

  init(): void {

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {

        // wait for angular render
        requestAnimationFrame(() => {

          this.reinitializeComponents();

        });

      });
  }

  reinitializeComponents(): void {

    try {

      // 🔥 reset menu initialized flags
      document
        .querySelectorAll('[data-kt-menu-initialized]')
        .forEach(x => {
          x.removeAttribute('data-kt-menu-initialized');
        });

      // 🔥 reset drawer initialized flags
      document
        .querySelectorAll('[data-kt-drawer-initialized]')
        .forEach(x => {
          x.removeAttribute('data-kt-drawer-initialized');
        });

      // 🔥 reset toggle initialized flags
      document
        .querySelectorAll('[data-kt-toggle-initialized]')
        .forEach(x => {
          x.removeAttribute('data-kt-toggle-initialized');
        });

      // 🔥 reinitialize ALL metronic components
      if (typeof KTComponents !== 'undefined') {

        KTComponents.init();

        console.log('KTComponents reinitialized');
      }

    } catch (e) {

      console.error('KTComponents init error', e);
    }
  }
}